module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/title_ribbon_01-72a574d3839f12fb23f8256b793e35c8.png";